import { GlSprintf } from '@gitlab/ui';
import { s__ } from '~/locale';
import DetailsRow from '~/vue_shared/components/registry/details_row.vue';
export default {
    name: 'MetadataMaven',
    i18n: {
        appGroup: s__('PackageRegistry|App group: %{group}'),
        appName: s__('PackageRegistry|App name: %{name}')
    },
    components: {
        DetailsRow,
        GlSprintf
    },
    props: {
        packageMetadata: {
            type: Object,
            required: true
        }
    }
};
